import script from "./GroupsModalsHub.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsModalsHub.vue?vue&type=script&setup=true&lang=js"

import "./GroupsModalsHub.vue?vue&type=style&index=0&id=3edb8d87&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3edb8d87"]])

export default __exports__